import { render, staticRenderFns } from "./_view.vue?vue&type=template&id=65559b5d"
import script from "./_view.vue?vue&type=script&lang=js"
export * from "./_view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports